import { render, staticRenderFns } from "./Stuffing.vue?vue&type=template&id=c2a74ef2&scoped=true"
import script from "./Stuffing.vue?vue&type=script&lang=js"
export * from "./Stuffing.vue?vue&type=script&lang=js"
import style0 from "./Stuffing.vue?vue&type=style&index=0&id=c2a74ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a74ef2",
  null
  
)

export default component.exports